import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { Opportunity } from '@merkl/api'

import { opportunitiesQueryOptions } from './query'
import { Address } from 'viem'

// export interface UseMerklOpportunitiesParams {}
export type UseMerklOpportunitiesResult = Pick<UseQueryResult<any>, 'data' | 'isLoading' | 'error'> & {
  findByIdentifier: (identifier: Address) => any
}

export function useMerklOpportunities(): UseMerklOpportunitiesResult {
  const query = useQuery({
    ...opportunitiesQueryOptions(),
  })

  function findByIdentifier(identifier: Address): Opportunity | undefined {
    return query.data?.find((opportunity) => opportunity.identifier === identifier)
  }

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    findByIdentifier,
  }
}
